import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import permissionDirective from './directives/permission'
import { thumbUrl } from './utils/image'


// 完全抑制 ResizeObserver 循环错误
(() => {
  const RESIZE_OBSERVER_ERROR = 'ResizeObserver loop completed with undelivered notifications'
  
  // 1. 直接阻止ResizeObserver错误
  const originalResizeObserver = window.ResizeObserver
  if (originalResizeObserver) {
    window.ResizeObserver = class extends originalResizeObserver {
      constructor(callback) {
        const wrappedCallback = (entries, observer) => {
          try {
            // 使用setTimeout延迟执行，避免同步触发
            setTimeout(() => {
              try {
                callback(entries, observer)
              } catch (e) {
                if (!e.message?.includes(RESIZE_OBSERVER_ERROR)) {
                  throw e
                }
              }
            }, 0)
          } catch (e) {
            if (!e.message?.includes(RESIZE_OBSERVER_ERROR)) {
              throw e
            }
          }
        }
        super(wrappedCallback)
      }
    }
  }

  // 2. 拦截控制台错误
  const originalConsoleError = console.error
  console.error = function(...args) {
    if (args.length > 0 && typeof args[0] === 'string' && args[0].includes(RESIZE_OBSERVER_ERROR)) {
      return
    }
    return originalConsoleError.apply(this, args)
  }

  // 3. 拦截控制台警告  
  const originalConsoleWarn = console.warn
  console.warn = function(...args) {
    if (args.length > 0 && typeof args[0] === 'string' && args[0].includes(RESIZE_OBSERVER_ERROR)) {
      return
    }
    return originalConsoleWarn.apply(this, args)
  }

  // 4. 全局错误事件拦截
  window.addEventListener('error', function(event) {
    if (event.message && event.message.includes(RESIZE_OBSERVER_ERROR)) {
      event.stopImmediatePropagation()
      event.preventDefault()
      return false
    }
  }, { capture: true, passive: false })

  // 5. Promise错误拦截
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && typeof event.reason === 'object' && 
        event.reason.message && event.reason.message.includes(RESIZE_OBSERVER_ERROR)) {
      event.preventDefault()
      return false
    }
  }, { capture: true, passive: false })

  // 6. 开发环境webpack错误拦截
  if (process.env.NODE_ENV === 'development') {
    // 拦截webpack dev server的错误处理
    const intervalId = setInterval(() => {
      try {
        const webpackClientKey = '__webpack_dev_server_client__'
        if (window[webpackClientKey]) {
          const client = window[webpackClientKey]
          if (client.overlay && client.overlay.handleError) {
            const originalHandler = client.overlay.handleError
            client.overlay.handleError = function(error) {
              if (error && error.message && error.message.includes(RESIZE_OBSERVER_ERROR)) {
                return
              }
              return originalHandler.call(this, error)
            }
            clearInterval(intervalId)
          }
        }
      } catch (e) {
        // 忽略webpack相关错误
      }
    }, 100)

    // 10秒后停止尝试
    setTimeout(() => clearInterval(intervalId), 10000)
  }

  // 7. 拦截其他可能的错误处理函数
  const originalHandleError = window.handleError
  if (typeof originalHandleError === 'function') {
    window.handleError = function(error) {
      if (error && error.message && error.message.includes(RESIZE_OBSERVER_ERROR)) {
        return
      }
      return originalHandleError.call(this, error)
    }
  }
})()

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(Antd)
// 列表缩略图：模板里用 $thumb(url) 取七牛小图，避免加载原图把浏览器卡死（大图预览仍用原图）
app.config.globalProperties.$thumb = thumbUrl
app.directive('permission', permissionDirective)
app.mount('#app')
